import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { fundingReportMatches as fundingReportMatchesType } from './types';
import { requestFundingReportMatchesSuccess, requestFundingReportMatchesFailure } from './reducer';

const logger = new Logger('Saga:FundingReport');

export function* requestFundingReportMatchesSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');
  const { reportId } = action;

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.monitor.funding_report_matches', { reportId }),
    );

    yield put(requestFundingReportMatchesSuccess(response.data));
  } catch (error) {
    logger.error('Failed to request funding report  matches with the following error', error);
    yield put(requestFundingReportMatchesFailure(error));
  }
}

export default function* fundingReportMatchesSaga() {
  return yield all([takeLatest(fundingReportMatchesType.request, requestFundingReportMatchesSaga)]);
}
